import React, { useRef, useEffect } from 'react';

import _ from 'lodash';
import cx from 'classnames';
import { useInView } from "react-intersection-observer";

import styles from './video.module.scss';
import {AnimationComponent} from '../../Animations';
import { HotspotTrigger } from '../../../components/hotspot';

import { Widgets } from './../../../index';

const VideoWidgetComponent = function ({ className, style, widgetProps, breakpoint }) {
  const videoAimation = _.get(widgetProps, `properties.${breakpoint}.animation`, {});

  const { ref, inView } = useInView({
    threshold: 0.3
  });

  const id = _.get(widgetProps, 'uid');
  const content = _.get(widgetProps, 'content');

  return (
    <HotspotTrigger widget={widgetProps} breakpoint={breakpoint} targetRef={ref}>
      <div id={id}
        ref={ref}
        className={cx(className, styles.video)}
        style={style}
        data-widget-id={id}
      >
        <AnimationComponent {...videoAimation}>
          <VideoView content={content} breakpoint={breakpoint} inView={inView} />
        </AnimationComponent>
      </div>
    </HotspotTrigger>
  )
}

const VideoView = ({ content, breakpoint, inView }) => {
  const videoRef = useRef(null);

  const context = React.useContext(Widgets.Context);
  const url = _.get(content, 'url');

  useEffect(() => {
    if (videoRef && videoRef.current) {
      if (inView) {
        videoRef.current.play();
      } else {
        videoRef.current.pause();
      }
    }
  }, [inView])

  useEffect(() => {
    if (!videoRef.current) {
      return;
    }

    var videoUrl = `${context.imageCDN}/${url}`;
    if (breakpoint === 'mobile') {
      var height = videoRef.current.offsetHeight;
      var maxHeight = _.get(content, 'media.height') || 1080;

      if (height <= 360) {
        height = 360;
      } else if (height <= 480) {
        height = 480;
      } else if (height <= 720) {
        height = 720;
      } else {
        height = 1080;
      }

      height = Math.min(height, maxHeight);

      if (height >= 360) {
        videoUrl = `${videoUrl}?tr=h-${height}`;
      }
    }

    videoRef.current.src = videoUrl;

  }, [breakpoint]);

  return (
    <React.Fragment>
      <video
        ref={videoRef}
        name='media'
        className={styles.videoPlayer}
        autoPlay
        muted
        loop
        playsInline
        poster={`${context.imageCDN}/${url}/ik-thumbnail.jpg`}
      />
    </React.Fragment>
  );
}

const videoWidgetEquals = function (prevProps, nextProps) {
  const paths = ['className', 'style', 'widgetProps', 'breakpoint'];
  const next = _.pick(nextProps, paths);
  const previous = _.pick(prevProps, paths);

  const equals = _.isEqual(next, previous);
  return equals;
}

export const VideoWidget = React.memo(VideoWidgetComponent, videoWidgetEquals);
